export const environment = {
  production: false,
  test: false,
  firebaseConfig: {
    apiKey: 'AIzaSyAKcCb_la-tupStUylZEPgeU66F4wlxlvc',
    authDomain: 'medilabb-test.firebaseapp.com',
    databaseURL: 'https://medilabb-test.firebaseio.com',
    projectId: 'medilabb-test',
    storageBucket: 'medilabb-test.appspot.com',
    messagingSenderId: '13156777576',
    appId: '1:13156777576:web:f89fa738f84e693a',
    measurementId: 'G-C3Y9VWKVR3'
  },
  Maps_API_KEY: 'AIzaSyAKcCb_la-tupStUylZEPgeU66F4wlxlvc',
  telegramBot: {
    token: '744340283:AAF9vHes626vyDRRDJIgYz7QQlxYpCr-XhI',
    link: 'https://t.me/medilabb_test_bot'
  },
  sentryDsn: 'https://dfbb0304e4a048c59a7a342c2a7c31ec@o324248.ingest.sentry.io/1826614',
  googleAnalyticsTrackingCode: '',
  facebookPixel: '',
  baseUrl: 'https://localhost:8100',
  supportMobile: '573044671248',
  supportChat: 'https://www.tidio.com/talk/medilabb',
  wsChat: 'https://wa.me/573044671248',
  routePaymentLink: 'https://checkout.wompi.co/l/test_Jk22k7',
  tutorialsLink: 'https://youtube.com/playlist?list=PLXzVCE9FJ__k_vbPpfbOcHK6imxedPBaI',
  politicasLink: 'https://drive.google.com/file/d/1DhI_-25LkUG8rxL9CgY7TYacvaTaANyh/view',
  terminosLink: 'https://drive.google.com/file/d/1WTHvkQi3IVD7oOZiQ7i-Yzmt-kBkS6ss/view',
  mapfreLink: 'https://www.saludplus.com.co/',
  version: 'test 2'
};
